var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('i-card',{attrs:{"title":"平台公告"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"title":"欢迎来到咪咕猫管理平台","name":"1"}},[_c('div',[_vm._v("你可以操作咪咕猫旅游平台的各种数据")])])],1)],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b14ee84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 